export const RESERVED_URLS = [
  '/admin',
  '/login',
  '/cart',
  '/checkout',
  '/api',
  '/account',
  '/settings',
] as const;
